module.exports = __webpack_public_path__ + "img/cases-brand-7-cover.b46f7e4b.png";